/**
 * SWAYM Premium Product Detail Controller (swaym-product.js)
 * Gallery crossfade, "Release" word auto-cycle, quantity stepper.
 */

(function () {
  document.querySelectorAll('.swaym-product-wrapper').forEach((section) => {
    initGallery(section);
    initReleaseWords(section);
    initQuantityStepper(section);
  });

  function initGallery(section) {
    const gallery = section.querySelector('[data-swaym-gallery]');
    if (!gallery) return;

    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const moreButton = gallery.querySelector('[data-gallery-more]');
    if (!mainImage || thumbs.length === 0) return;

    function swapImage(button) {
      const src = button.getAttribute('data-full-src');
      const alt = button.getAttribute('data-alt');
      if (!src) return;

      thumbs.forEach((t) => t.classList.remove('is-active'));
      button.classList.add('is-active');

      if (typeof gsap !== 'undefined') {
        gsap.to(mainImage, {
          opacity: 0,
          duration: 0.18,
          onComplete: () => {
            mainImage.src = src;
            if (alt) mainImage.alt = alt;
            gsap.to(mainImage, { opacity: 1, duration: 0.25 });
          }
        });
      } else {
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => swapImage(thumb));
    });

    if (moreButton) {
      let rotation = 0;
      moreButton.addEventListener('click', () => {
        rotation = (rotation + 1) % thumbs.length;
        swapImage(thumbs[rotation]);
      });
    }
  }

  function initReleaseWords(section) {
    const release = section.querySelector('[data-swaym-release]');
    if (!release) return;

    const wordEl = release.querySelector('[data-release-word]');
    const words = (release.getAttribute('data-words') || '').split('|').filter(Boolean);
    if (!wordEl || words.length < 2) return;

    let index = 0;

    function cycle() {
      index = (index + 1) % words.length;

      if (typeof gsap !== 'undefined') {
        gsap.to(wordEl, {
          y: -8,
          opacity: 0,
          duration: 0.25,
          onComplete: () => {
            wordEl.textContent = words[index];
            gsap.fromTo(wordEl, { y: 8, opacity: 0 }, { y: 0, opacity: 1, duration: 0.3 });
          }
        });
      } else {
        wordEl.textContent = words[index];
      }
    }

    setInterval(cycle, 2600);
  }

  function initQuantityStepper(section) {
    section.querySelectorAll('[data-quantity-input]').forEach((wrapper) => {
      const input = wrapper.querySelector('.swaym-product-quantity__input');
      const minus = wrapper.querySelector('[data-quantity-minus]');
      const plus = wrapper.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;

      const trackInventory = wrapper.getAttribute('data-track-inventory') === 'true';
      const inventoryMax = parseInt(wrapper.getAttribute('data-inventory-max'), 10) || 0;

      function bounce(button) {
        if (typeof gsap === 'undefined') return;
        gsap.fromTo(
          button,
          { scale: 1 },
          { scale: 0.85, duration: 0.1, yoyo: true, repeat: 1, ease: 'power1.inOut' }
        );
      }

      function updateButtonState() {
        const value = parseInt(input.value, 10) || 1;
        const min = parseInt(input.min, 10) || 1;
        minus.disabled = value <= min;
        plus.disabled = trackInventory && inventoryMax > 0 && value >= inventoryMax;
      }

      minus.addEventListener('click', () => {
        const min = parseInt(input.min, 10) || 1;
        const value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        bounce(minus);
        updateButtonState();
      });

      plus.addEventListener('click', () => {
        let value = (parseInt(input.value, 10) || 1) + 1;
        if (trackInventory && inventoryMax > 0) {
          value = Math.min(value, inventoryMax);
        }
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        bounce(plus);
        updateButtonState();
      });

      updateButtonState();
    });
  }
})();
